<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 25 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6739_810)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.33325 16H12.4999V4H9.33325V16Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.16675 16H6.2501V4H4.16675V16Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.6667 16H18.7501V4H16.6667V16Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.75 2.00001H22.9167V5.99998H25V1.84C25 0.928222 24.0331 0 23.0834 0H18.75V2.00001H18.75Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.9167 18H18.75V20H23.0833C24.0331 20 25 19.0718 25 18.16V14H22.9167V18H22.9167Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.57804e-06 18.16C8.57804e-06 19.0718 0.966883 20 1.91665 20H6.25V18H2.08332V14H0V18.16H8.57804e-06Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 1.84V5.99998H2.08332V2.00001H6.25V0H1.91665C0.966883 0 8.57805e-06 0.928222 8.57805e-06 1.84H0Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.75 16H20.8333V4H19.75V16Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.5 16H14.5833V4H13.5V16Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.25 16H8.33333V4H7.25V16Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6739_810">
        <rect width="25" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
